import { MESSAGES } from '../../constant/messages';
import { MINIMUM_ORDER_QUANTITY_TYPE } from '../../constant/product-option';

export const getMinimumOrderQuantityToastMessage = (
  minimum_order_quantity_type: string,
  min_order_quantity: number,
) => {
  switch (minimum_order_quantity_type) {
    case MINIMUM_ORDER_QUANTITY_TYPE.PRODUCT:
      return `${min_order_quantity}개부터 구매 가능합니다.`;
    case MINIMUM_ORDER_QUANTITY_TYPE.ITEM:
      return `옵션별 ${min_order_quantity}개부터 구매 가능합니다.`;
    default:
      return '';
  }
};

export const getLimitOverMaxMessage = (has_first_order_discount: boolean, has_store_deal_banner: boolean) => {
  if (has_first_order_discount) {
    return MESSAGES.FIRST_ORDER_DISCOUNT;
  }

  if (has_store_deal_banner) {
    return MESSAGES.STORE_DEAL_MAX_SELECTION;
  }
  return '';
};
